export default __webpack_public_path__ + "static/BUIE-6f3879a650bf3a4d21b89f2f7f7b9b99.png";